import { useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
// import SettingsSecurity from './settingsSecurity/SettingsSecurity';
import SettingsNotifications from './settingsNotifications/SettingsNotifications';
import SettingsShipping from './settingsShipping/SettingsShipping';
import ShopSettingsDesign from './settingsDesign/SettingsDesign';
import SettingsMarketing from './settingsMarketing/SettingsMarketing';
import SubPageContentHolder from '../../components/subPageContentHolder/SubPageContentHolder';
import SettingsSecurity from './settingsSecurity/SettingsSecurity';
import SettingsConvenienceFee from './settingsConvenienceFee/SettingsConvenienceFee';
import SettingsDiscounts from './settingsDiscounts/SettingsDiscounts';
import PageWrapperMain from '../../components/page-wrappers/PageWrapperMain';
import ShopSettingsWebhooks from './settingsWebhooks/SettingsWebhooks';
import { allRoutes } from '../../lib/constants/route';
import PSP from './psp/PSP';
import ShopSettings from './settingsShop/ShopSettings';
import CommunicationSettings from './settingsCommunication/CommunicationSettings';
import GeneralSettings from './settingsGeneral/GeneralSettings';
import ProfileSettings from './settingsProfile/ProfileSettings';
import APIKeySettings from './settingsAPIKeys/APIKeySettings';
import SubscriptionSettings from './settingsSubscription/SubscriptionSettings';
import SettingsTara from './settingsTara/SettingsTara';

const SettingsPage = () => {
  const navigate = useNavigate();
  const currentPath = window.location.pathname;

  useEffect(() => {
    if (currentPath === '/settings') {
      navigate('/settings/general');
    }
  }, [currentPath, navigate]);

  return (
    <PageWrapperMain>
      <div className='subPage'>
        <SubPageContentHolder>
          <Routes>
            {allRoutes['/settings/general'] && (
              <Route path='general/*' element={<GeneralSettings />} />
            )}
            {allRoutes['/settings/appearance'] && (
              <Route path='appearance/*' element={<ShopSettingsDesign />} />
            )}
            {allRoutes['/settings/payments'] && (
              <Route path='payments/*' element={<PSP />} />
            )}
            {allRoutes['/settings/shipping'] && (
              <Route path='shipping/*' element={<SettingsShipping />} />
            )}
            {allRoutes['/settings/convenienceFee'] && (
              <Route
                path='convenienceFee/*'
                element={<SettingsConvenienceFee />}
              />
            )}
            {allRoutes['/settings/discounts'] && (
              <Route path='discounts/*' element={<SettingsDiscounts />} />
            )}
            {allRoutes['/settings/notifications'] && (
              <Route
                path='notifications/*'
                element={<SettingsNotifications />}
              />
            )}
            {allRoutes['/settings/webhooks'] && (
              <Route path='webhooks/*' element={<ShopSettingsWebhooks />} />
            )}
            {allRoutes['/settings/marketing'] && (
              <Route path='marketing/*' element={<SettingsMarketing />} />
            )}
            {allRoutes['/settings/security'] && (
              <Route path='security/*' element={<SettingsSecurity />} />
            )}
            {allRoutes['/settings/profile'] && (
              <Route path='profile/*' element={<ProfileSettings />} />
            )}
            {allRoutes['/settings/subscription'] && (
              <Route path='subscription/*' element={<SubscriptionSettings />} />
            )}
            {allRoutes['/settings/api-keys'] && (
              <Route path='api-keys/*' element={<APIKeySettings />} />
            )}
            {allRoutes['/settings/communication'] && (
              <Route
                path='communication/*'
                element={<CommunicationSettings />}
              />
            )}
            {allRoutes['/settings/brand'] && (
              <Route path='brand/*' element={<ShopSettings />} />
            )}
            {allRoutes['/settings/tara'] && (
              <Route path='tara/*' element={<SettingsTara />} />
            )}
          </Routes>
        </SubPageContentHolder>
      </div>
    </PageWrapperMain>
  );
};

export default SettingsPage;
